import type { GetDisplayGroup_getDisplayGroup_DisplayGroupV2 } from '../../hooks/__generated__/GetDisplayGroup'

export type DisplayGroupBoardLayout = {
  id: string
  boardStyle: string
}

export type DisplayGroupLayout = {
  boards: DisplayGroupBoardLayout[][]
}

export const buildDisplayGroupLayout = (
  displayGroup: GetDisplayGroup_getDisplayGroup_DisplayGroupV2
): DisplayGroupLayout => ({
  boards: displayGroup.boards.map(row =>
    row.map(entry => ({
      id: entry.board.id,
      boardStyle: entry.board.boardStyle ?? 'note-black'
    }))
  )
})
